<template>
  <el-carousel trigger="click" :height="bannerHeight+'px'" arrow="hover">
    <el-carousel-item v-for="item in images" :key="item.url">
      <el-image placeholder="图片加载中。。。" ref="bannerHeight" class="image" :src="item.url"/>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: 'Banner',
  data () {
    return {
      images: [
        { url: require('../../assets/images/banner/banner1.jpg') },
        { url: require('../../assets/images/banner/banner3.jpg') },
        { url: require('../../assets/images/banner/banner4.jpg') },
      ],
      bannerHeight: ''
    }
  },

  created () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize (event) {
      this.bannerHeight = document.documentElement.clientWidth * 937 / 1920
    }
  }
}
</script>

<style scoped>

</style>
